export default (text, placeholders) => {
	if (typeof text !== "string" || !text) {
		return text || "";
	}

	const formatted = text.replace(/<(\S+)>/g, (match, key) => {
		return placeholders[key] !== undefined ? placeholders[key] : "-";
	});

	return formatted;
};
